<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template #activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon small>
          fas fa-play
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Please confirm execute!</v-card-title>
      <v-card-text>Sure want to execute this {{ task.name }} schedule immediately?</v-card-text>
      <v-alert
        v-if="errorMsg !== ''"
        type="error"
      >
        {{ errorMsg === null ? 'Execut Fail!' : errorMsg }}
      </v-alert>
      <v-alert
        v-if="succesMsg !== ''"
        type="success"
      >
        {{ succesMsg }}
      </v-alert>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          text
          :loading="loading"
          :disabled="countDown > 0"
          color="warning"
          @click="exec"
        >
          Execute
          <span v-if="countDown > 0">({{ countDown }})</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { scheduler } from '@rhitics/core'

export default {
  name: 'TaskExecDialog',

  props: {
    task: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      countDown: 0,
      dialog: false,
      loading: false,
      errorMsg: '',
      succesMsg: ''
    }
  },

  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.errorMsg = ''
      this.succesMsg = ''
    },
    async exec() {
      this.init()
      try {
        this.loading = true
        const response = await scheduler.task.exec(this.task.id)
        console.info(response)
        if (response.ok === false) {
          this.errorMsg = response.data
        } else {
          this.succesMsg = response.data
        }
      } catch (error) {
        console.error(error)
        this.errorMsg = error.message
      }
      this.loading = false
      this.setCountDown()
    },
    setCountDown() {
      this.countDown = 6
      this.intervalId = setInterval(() => {
        if (this.countDown === 0) {
          clearInterval(this.intervalId)
        } else {
          this.countDown--
        }
      }, 1000)
    }
  }
}
</script>

<style></style>
